import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import mainReducer from './mainReducer';
const rootReducer = combineReducers({
    main: mainReducer,
});
export const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        immutableCheck: { warnAfter: 128 },
    }),
});
export const useAppSelector = useSelector;
